// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"0":"226272fc7d89d55e120c","609":"29a0c09fbecabc0e15b5","685":"9ad7864cbde60688c3ad","766":"6a88a61c9b2e64cd5c45"}[chunkId] + ".chunk.js";
};